import { Action } from 'redux'
import { PlayerCapabilities } from 'ATVWebPlayer'
import { store } from '../store'
import { DetailPageActionTypes } from './constants'
import { refreshMainActionBox, refreshEpisode } from './wps'
import { playbackIdToCanonicalIdSelector } from '../selectors/player'
import { isMovieSelector } from '../selectors/detailFragment'
import {
  PlayerContentConfig,
  PlaybackContentLink,
} from '../integrations/playerIntegration'

export interface ISetPlayerCapabilities extends Action {
  type: typeof DetailPageActionTypes.SetPlayerCapabilities
  payload: {
    capabilities: PlayerCapabilities
  }
}

export interface IPlaybackStart extends Action {
  type: typeof DetailPageActionTypes.PlaybackStart
  payload: PlaybackContentLink
}

export interface IPlaybackFailed extends Action {
  type: typeof DetailPageActionTypes.PlaybackFailed
}

export interface IPlaybackClosed extends Action {
  type: typeof DetailPageActionTypes.PlaybackClosed
  payload: {
    content: PlayerContentConfig
  }
}

export const setPlayerCapabilities = (
  capabilities: PlayerCapabilities
): ISetPlayerCapabilities => ({
  type: DetailPageActionTypes.SetPlayerCapabilities,
  payload: {
    capabilities,
  },
})

export const startPlayback = (
  payload: PlaybackContentLink
): IPlaybackStart => ({
  type: DetailPageActionTypes.PlaybackStart,
  payload,
})

export const playerClosedOrTitleChanged = (
  opts: PlayerContentConfig,
  isClosed = true
) => {
  if (isClosed) {
    store.dispatch({
      type: DetailPageActionTypes.PlaybackClosed,
      payload: {
        content: opts,
      },
    })
  }
  const state = store.getState()
  const canonicalTitleIdMap = playbackIdToCanonicalIdSelector(state)
  const isMovie = isMovieSelector(state)
  if (opts && !opts.trailer && opts.asin) {
    const canonicalTitleId =
      (canonicalTitleIdMap && canonicalTitleIdMap[opts.asin]) || opts.asin
    refreshMainActionBox(state.pageTitleId, canonicalTitleId, canonicalTitleId)
    if (!isMovie) {
      refreshEpisode(canonicalTitleId)
    }
  }
}
